import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { slugify } from '../../../utils/slugify';

//components
import { FormattedNumber } from 'react-intl';
import { Checkbox } from 'dibs-elements/exports/Checkbox';
import { AbsoluteAnchor } from '../../../global/AbsoluteAnchor/AbsoluteAnchor';

// styles
import styles from './SbSharedRefineMenuInput.scss';

export function SbSharedRefineMenuInputCheckbox(props) {
    const { text, count, className, value, checked, onChange, seoLink, isHidden } = props;
    const containerClass = classnames(styles.container, className, {
        'is-hidden': isHidden,
    });

    return (
        <div className={containerClass}>
            <AbsoluteAnchor
                href={seoLink}
                className={styles.input}
                onClick={e => e.preventDefault()}
            >
                <div onClick={e => e.stopPropagation()}>
                    <Checkbox
                        labelClass={styles.text}
                        value={value}
                        checked={checked}
                        name={text}
                        label={text}
                        onChange={onChange}
                        dataTn={`facet-content-${slugify(text)}`}
                    />
                </div>
            </AbsoluteAnchor>
            {!!count && (
                <span className={styles.count} data-tn={`facet-count-${slugify(text)}`}>
                    <FormattedNumber value={count} />
                </span>
            )}
        </div>
    );
}

SbSharedRefineMenuInputCheckbox.propTypes = {
    count: PropTypes.number,
    text: PropTypes.string.isRequired,
    className: PropTypes.string,
    checked: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string.isRequired,
    seoLink: PropTypes.string,
    isHidden: PropTypes.bool,
};
